import {
  CLEAR_PRODUCT_ACCESSORIES,
  FETCH_PRODUCT_ACCESSORIES,
  FETCH_PRODUCT_ACCESSORIES_FULFILLED,
  FETCH_PRODUCT_ACCESSORIES_REJECTED,
} from 'b2b-apps/shop/product/redux/productAccessories/actionTypes';
import {
  ClearProductAccessoriesAction,
  FetchProductAccessoriesAction,
  FetchProductAccessoriesFulfilledAction,
  FetchProductAccessoriesRejectedAction,
  ProductAccessoriesType,
} from 'b2b-apps/shop/product/redux/productAccessories/types';

const clearProductAccessories = (): ClearProductAccessoriesAction => ({
  type: CLEAR_PRODUCT_ACCESSORIES,
});

const fetchProductAccessories = (
  sku: string,
): FetchProductAccessoriesAction => ({
  type: FETCH_PRODUCT_ACCESSORIES,
  payload: {
    sku,
  },
});

const fetchProductAccessoriesFulfilled = (
  sku: string,
  response: ProductAccessoriesType,
): FetchProductAccessoriesFulfilledAction => ({
  type: FETCH_PRODUCT_ACCESSORIES_FULFILLED,
  payload: {
    data: response,
    sku,
  },
});

const fetchProductAccessoriesRejected = (
  sku: string,
  error: ErrorType,
): FetchProductAccessoriesRejectedAction => ({
  type: FETCH_PRODUCT_ACCESSORIES_REJECTED,
  payload: {
    error,
    sku,
  },
});

export {
  clearProductAccessories,
  fetchProductAccessories,
  fetchProductAccessoriesFulfilled,
  fetchProductAccessoriesRejected,
};
